import React, { useState } from "react";
import PGARecentHistory from "../../../../DraftKingsInfoOverlay/PGARecentHistory";
import { useParams } from "react-router-dom";
import "./PGAProfilePage.css";
import PGAProfileHeader from "./PGAProfileHeader";

export default function PGAProfilePage(props) {
  const { playerId } = useParams();

  return (
    <div className="pga-profile-page-container">
      <React.Suspense fallback={""}>
        <PGAProfileHeader playerId={playerId} />
      </React.Suspense>
      <React.Suspense fallback="Loading recent history...">
        <h2>Round History</h2>
        <PGARecentHistory playerId={playerId} showMore={true} />
      </React.Suspense>
    </div>
  );
}
